/**
 * Sets the backup image to display if the image can not be displayed
 */
angular.module('qkr').directive('fallbackSrc', (utils) => {
    const fallbackSrc = {
        link: function postLink(scope, iElement, iAttrs) {
            // Only do this on an error
            iElement.bind('error', function() {
                const cur = angular.element(this).attr('src');
                // Don't do this more than once - i.e. don't get into an infinite loop failing to
                // Load the fallback image
                if (cur !== iAttrs.fallbackSrc) {
                    angular.element(this).attr('src', utils.checkSSL(iAttrs.fallbackSrc));
                }
            });
        }
    };
    return fallbackSrc;
});




// WEBPACK FOOTER //
// ./src/directives/fallback_image.js